export default __webpack_public_path__ + "static/media/Screenshot_2.30bbdca0.png";